import i18next from '../../locales/i18n';

export const CreateTabsEnum = {
  SINGLE: i18next.t('addEan.single'),
  BULK: i18next.t('addEan.bulk'),
  ASYNC: i18next.t('addEan.async'),
  PREVIEW: i18next.t('addEan.preview'),
  EDIT: i18next.t('addEan.edit')
};
